import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { IoCall } from "react-icons/io5";
import BasicSpeedDial from "../pages/BasicSpeedDial";
import { useNavigate } from "react-router-dom";
import { BsFillChatRightDotsFill } from "react-icons/bs";

const HomeClickAstro = () => {
  const navigate = useNavigate();

  return (
    <div
      className="d-lg-none"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "-webkit-fill-available",
        position: "fixed",
        top: "91%",
        gap: "1.5rem",
      }}
    >
      <Button
        className="all_btn_color"
        style={{
          fontSize: "16px",
          borderRadius: "50px",
          height: "max-content",
          padding: "10px 25px",
        }}
        onClick={() => navigate("talktoconsultant")}
      >
        <IoCall /> Call Now
      </Button>
      <Button
        className="all_btn_color"
        style={{
          fontSize: "16px",
          borderRadius: "50px",
          height: "max-content",
          border: "1px solid blue",
          padding: "10px 25px",
        }}
        onClick={() => {
          navigate("ourcallservices");
          sessionStorage.setItem("consultantType", "Chat");
        }}
      >
        <BsFillChatRightDotsFill /> Chat Now
      </Button>
    </div>
  );
};

export default HomeClickAstro;
